import React from "react";
import SwiperCore, { Navigation, A11y, SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { PANTRYSHOP_COLORS } from "@pepdirect/ui/theme/PantryShopTheme";
import { BundleTile } from "components/BundleTile";
import { Heading } from "@pepdirect/ui/heading";
import st from "./recommended.module.scss";
import { RecommendedProductFragment } from "services/graphql/generated";
import { Product } from "@pepdirect/shared/types";

SwiperCore.use([Navigation, A11y]);

export function Recommended({
  products,
}: {
  products: RecommendedProductFragment[];
}): JSX.Element | null {
  const options: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 20,
    freeMode: true,
    navigation: {
      nextEl: "#recommended-next-slide",
      prevEl: "#recommended-prev-slide",
    },
    breakpoints: {
      1024: {
        slidesPerView: Math.min(3, products.length),
        freeMode: false,
      },
    },
  };
  return products.length > 0 ? (
    <div className={st.wrapper}>
      <div className={st.title}>
        <Heading level="h2" size="l" color={PANTRYSHOP_COLORS.orange} center>
          Pantry Favorites
        </Heading>
      </div>
      <div className={st.recommended}>
        <div
          className={`${st.prev} swiper-button-custom--prev`}
          id="recommended-prev-slide"
        />
        <Swiper {...options}>
          {products.map((item) => (
            <SwiperSlide key={item._id} className={st.slide}>
              <BundleTile item={item as Product} isInRecommendedSection />
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className={`${st.next} swiper-button-custom--next`}
          id="recommended-next-slide"
        />
      </div>
    </div>
  ) : null;
}
